export default {
  state: {
    dialogMontaje: false,
    tipoMontaje: 'ninguno'
  },
  getters: {
    getDialogMontaje: (state) => {
      return state.dialogMontaje
    },
    getTipoMontaje: (state) => {
      return state.tipoMontaje
    }
  },
  mutations: {
    setDialogMontaje: (state, estado) => {
      state.dialogMontaje = estado
    },
    setTipoMontaje: (state, tipo) => {
      state.tipoMontaje = tipo
    }
  },
  actions: {

  }
}
